"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _CardContext = require("../context/CardContext");

var _decorators = require("../utils/propTypes/decorators");

var scrollableMixin = (0, _styledComponents.css)(["flex:1 1 auto;overflow:auto;&:last-child{margin-bottom:", ";}"], function (_ref) {
  var compact = _ref.compact;
  return compact ? '24px' : '40px';
});
var siblingPaddingMixin = (0, _styledComponents.css)(["+ .private-card__section,+ * .private-card__section{padding-top:0;}"]);

var Section = _styledComponents.default.div.withConfig({
  displayName: "UICardSection__Section",
  componentId: "mnuwaf-0"
})(["padding:", ";border-radius:inherit;", ";"], function (_ref2) {
  var compact = _ref2.compact,
      flush = _ref2.flush,
      isHeader = _ref2.isHeader,
      scrollable = _ref2.scrollable;
  var paddingTop = compact ? '24px' : '40px';
  var paddingBottom = isHeader || scrollable ? '0' : paddingTop;
  var paddingX = flush ? '0' : paddingTop;
  return paddingTop + " " + paddingX + " " + paddingBottom;
}, function (_ref3) {
  var scrollable = _ref3.scrollable;
  return scrollable ? scrollableMixin : siblingPaddingMixin;
});

var UICardSection = (0, _react.forwardRef)(function (props, ref) {
  var className = props.className,
      rest = (0, _objectWithoutProperties2.default)(props, ["className"]);

  var _useContext = (0, _react.useContext)(_CardContext.CardContext),
      compact = _useContext.compact;

  return _react.default.createElement(Section, Object.assign({}, rest, {
    ref: ref,
    className: (0, _classnames.default)('private-card__section', 'has--vertical-spacing', className),
    compact: compact
  }));
});
UICardSection.defaultProps = {
  flush: false,
  isHeader: false,
  scrollable: false
};
UICardSection.propTypes = {
  children: _propTypes.default.node,
  flush: _propTypes.default.bool,
  isHeader: (0, _decorators.hidden)(_propTypes.default.bool),
  scrollable: _propTypes.default.bool
};
UICardSection.displayName = 'UICardSection';
var _default = UICardSection;
exports.default = _default;
module.exports = exports.default;